const DISCONNECTED = 'DISCONNECTED';
const RECONNECTED = 'RECONNECTED';

export default {
  DISCONNECTED,
  RECONNECTED,
};
